import { pushEvent } from 'Utils/datalayer';
import { intersectionViewportObserver } from 'Utils/';

export const setupCardImpressions = {
  methods: {
    setupCardImpressions() {
      this.$slots.default?.[0]?.children?.forEach((node) => {
        if (node.tag === undefined) return;
        const impressionDataRaw = node?.data?.attrs['data-impressions'];
        let impressionData =
          typeof impressionDataRaw === 'string'
            ? JSON.parse(impressionDataRaw)
            : impressionDataRaw;
        const impressionLabel = node?.data?.attrs['data-label'];
        if (impressionData && impressionLabel) {
          intersectionViewportObserver(node.elm, { checkIsVisible: true }).then(
            () => {
              pushEvent({
                event: 'nievent',
                eventCategory: 'Ecommerce',
                eventAction: 'Product Impressions',
                eventLabel: impressionLabel,
                ecommerce: {
                  impressions: impressionData,
                },
              });
            }
          );
        }
      });
    },
  },
};
